import dayjs, { extend } from 'dayjs';
import utc from 'dayjs/plugin/utc';

import { errors } from './report-errors.constant';

extend(utc);

export const getError = (code: string, cutoff: number) => {
  try {
    return errors[code as keyof typeof errors] ? errors[code as keyof typeof errors](cutoff) : code;
  } catch (e) {
    return code;
  }
};

export const formatTTime = (value: number) => {
  try {
    if (isNaN(value)) {
      return '';
    }
    return `(${dayjs.utc(value * 3600000).format('HH:mm')})`;
  } catch (error) {
    return '';
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const computeAHICategory = (AHI: any) => {
  if (isNaN(AHI)) return AHI;
  if (AHI >= 0 && AHI < 5) return 'No OSA';
  else if (AHI >= 5 && AHI < 15) return 'Mild';
  else if (AHI >= 15 && AHI < 30) return 'Moderate';
  else if (AHI >= 30) return 'Severe';
  else return 'Not Available';
};

export const formatAHI = (value: number | string | undefined | null): string => {
  if (value === null || value === undefined || value === '') {
    return 'N/A';
  }
  const numValue = parseFloat(value.toString());
  if (isNaN(numValue)) {
    return 'N/A';
  }
  return numValue.toFixed(2);
};
